/*
 * Public API Surface of ui
 */
import {NgModule} from '@angular/core';

import {
  NgbPopoverModule,
  NgbModalModule,
  NgbProgressbarModule,
  NgbPaginationModule,
  NgbDropdownModule
} from '@ng-bootstrap/ng-bootstrap';

import {
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
  NgbModalConfig
} from '@ng-bootstrap/ng-bootstrap';

import {
  NgbPagination,
  NgbPaginationEllipsis,
  NgbPaginationFirst,
  NgbPaginationLast,
  NgbPaginationNext,
  NgbPaginationNumber,
  NgbPaginationPrevious,
  NgbPaginationConfig,
} from '@ng-bootstrap/ng-bootstrap';

import { NgbPopover, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';

export { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef, NgbModalConfig };
export { UiIconModule, UiLoaderModule };
export { NgbPagination,
  NgbPaginationEllipsis,
  NgbPaginationFirst,
  NgbPaginationLast,
  NgbPaginationNext,
  NgbPaginationNumber,
  NgbPaginationPrevious,
  NgbPaginationConfig
};

export { NgbPopover, NgbPopoverConfig };

import {UiCheckboxModule} from './checkbox/checkbox.module';
import {UiFieldModule} from './field/field.module';
import {UiComboboxModule} from './combobox/combobox.module';
import {UiMulticomboboxModule} from './multicombobox/multicombobox.module';
import {UiCheckboxSliderModule} from './checkbox-slider/checkbox-slider.module';
import {DateTimePickerModule} from './date-time-picker/date-time-picker.module';
import {UiIconModule} from './icon/icon.module';
import {UiLoaderModule} from './loader/loader.module';
import {UiMessageModule} from './message/message.module';
import {UiRadioButtonModule} from './radio-button/radio-button.module';
import {UiSelectModule} from './select/select.module';
import {UiCardModule} from './card/card.module';
import {UiTabsModule} from './tabs/tabs.module';
import {UiAutocompleteModule} from './autocomplete/autocomplete.module';
import {UiPaginationModule} from './pagination/pagination.module';
export {UiPaginationConfig} from './pagination/pagination-config.interface';

export const UiModules = [
  NgbPopoverModule,
  NgbModalModule,
  NgbProgressbarModule,
  NgbPaginationModule,
  NgbDropdownModule,
  UiCheckboxModule,
  UiFieldModule,
  UiComboboxModule,
  UiMulticomboboxModule,
  UiAutocompleteModule,
  UiCheckboxSliderModule,
  DateTimePickerModule,
  UiIconModule,
  UiLoaderModule,
  UiMessageModule,
  UiRadioButtonModule,
  UiSelectModule,
  UiCardModule,
  UiTabsModule,
  UiPaginationModule
];

@NgModule({
  imports: UiModules,
  exports: UiModules
})
export class UiAngularModule {
}
